/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ValidationStatus } from '../enums';

type OnChangeHandler = () => void;

export class ValidationState {
    private status: ValidationStatus = ValidationStatus.Common;
    private onChangeHandler: OnChangeHandler = null;

    markAsForce(): void {
        if (this.status !== ValidationStatus.Force) {
            this.status = ValidationStatus.Force;
            this.onChangeHandler?.call(null);
        }
    }

    markAsHandledForce(): void {
        if (this.status !== ValidationStatus.HandledForce) {
            this.status = ValidationStatus.HandledForce;
            this.onChangeHandler?.call(null);
        }
    }

    markAsCommon(): void {
        if (this.status !== ValidationStatus.Common) {
            this.status = ValidationStatus.Common;
            this.onChangeHandler?.call(null);
        }
    }

    isCommon(): boolean {
        return this.status === ValidationStatus.Common;
    }

    isForce(): boolean {
        return this.status === ValidationStatus.Force;
    }

    isHandledForce(): boolean {
        return this.status === ValidationStatus.HandledForce;
    }

    getStatus(): ValidationStatus {
        return this.status;
    }

    onChange(handler: OnChangeHandler): void {
        this.onChangeHandler = handler;
    }

    destroyObject(): void {
        this.onChangeHandler = undefined;
    }
}
